<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/WScxEa/tc-custom/9781626816534.jpg?1734325120858" alt="This image is the cover for the book Abu Wahab Caper, The Chance Purdue Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Abu Wahab Caper, The Chance Purdue Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>All bets are off when Chicago detective Chance Purdue protects a gambler with a target on his head in this PI parody from the author of <i>The Dada Caper</i>.</b><br/>  <br/> “Bet-a-Bunch” Dugan is being hunted by International DADA (Destroy America, Destroy America) conspirators, a terrorist organization out for control of the world’s oil market. Dugan needs more than a little luck to walk away unscathed. He needs a Chance, and though he knows that half of Purdue’s reputation is that of a guy you are aching to punch, the other half is that he’s a dogged, if occasionally doomed, investigator.<br/>  <br/> No matter where Purdue’s leads take him, though, he always seems to be one step behind DADA. As the hapless Chance watches DADA’s deadly scheme move forward, a siren named Brandy Alexander enters the picture and things finally fall into place, or so Chance hopes . . .<br/>  <br/><b>Praise for Ross H. Spencer’s <i>The Dada Caper</i></b><br/> “Parodies of the private‐eye novel come and go. Here is <i>The Dada Caper</i> by Ross H. Spencer. It has every cliché down pat, including rat-tat-tat writing in which paragraphs are seldom more than one sentence. . . . The hero is a private eye who is always tailing the wrong people and hitting the wrong guys. <i>The Dada Caper</i> is wild, shrewd, mad and unexpectedly funny.” —<i>The New York Times</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ross H. Spencer
      </h2>
      
      <p class="authorDescription body article">Ross H. Spencer (1921–1998) was a mystery author, best known for his series of comic novels that astutely satirized the private eye genre.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6a9c3f82